/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Upoznaj nove ljude, čavrljaj, druži se",
      "Pogrešan broj telefona",
      "Get the app",
      "Nastavi koristeći Apple",
      "Nastavi koristeći Facebook",
      "Nastavi koristeći Google",
      "Prijavi se",
      "Registruj se",
      "Da nastaviš, unesi znakove koje vidiš u polje za unos:",
      "Nastavi",
      "Unesi znakove",
      "Sigurnosna provjera",
      "Ponovo učitaj",
      "Kreiraj novu lozinku koju ćeš lako pamtiti:",
      "Ažuriraj",
      "Potvrdi lozinku",
      "Lozinka mora imati barem {{num}} [[characters:num]].",
      "Lozinka",
      "Kreiraj novu lozinku",
      "Badoo - Blog",
      "Zaposlenje",
      "Čavrljanje",
      "Gradovi",
      "Upravljaj kolačićima",
      "Autorska prava © 2006 – danas. Bumble. Sva prava zadržana.",
      "Apple i Apple logo su robne marke kompanije Apple Inc.{{__EOL__}}Google Play je robna marka kompanije Google LLC.",
      "Preuzmi",
      "Facebook",
      "Prati nas",
      "Centar za pomoć",
      "Instagram",
      "Jezik",
      "LinkedIn",
      "Pregled",
      "Badoo je dio kompanije Bumble Inc.",
      "Politika privatnosti",
      "Safety Centre",
      "Karta internetske stranice",
      "Izjava o modernom ropstvu",
      "Pravila i uslovi korištenja",
      "Twitter",
      "Unesi svoju adresu e-pošte ili broj telefona i poslat ćemo ti upute za kreiranje nove lozinke.",
      "Zatraži novu lozinku",
      "Unesi adresu e-pošte ili broj telefona",
      "Zaboravljena lozinka",
      "Modeli se koriste samo u svrhe ilustracije",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Ne moraš čekati da se svidite jedno drugome.{{__EOL__}}{{__EOL__}}Započni čavrljanje kroz koje ćete se upoznati i možete preskočiti formalnosti i odmah prijeći na ono najbitnije—upoznavanje.",
      "Spremni ste za čavrljanje sad?",
      "Nastaviš li s registracijom prihvataš <a class=\"link\" href=\"{{terms_url}}\">Uslove korištenja</a>. Saznaj više o tome kako koristimo tvoje podatke u <a class=\"link\" href=\"{{privacy_url}}\">Politici privatnosti</a>",
      "Pomažemo ti da budeš autentičan/a i <br />da uživaš u upoznavanju.",
      "Za upoznavanje sa samopouzdanjem",
      "ili",
      "Već imaš nalog?",
      "Prijavi se putem e-maila ili broja telefona",
      "Uživaj u upoznavanju.{{__EOL__}}Budi bez brige.",
      "Želiš samo čavrljati? U redu.{{__EOL__}}Želiš nešto ozbiljno?I to je u redu.{{__EOL__}}{{__EOL__}}Ako se ikada predomisliš, možeš to promijeniti u bilo kom trenutku.",
      "Želim upoznavanje",
      "Traže ozbiljnu vezu",
      "Čavrljanje",
      "Upoznaj ljude koji žele što i ti.",
      "{{name}}, {{age}}",
      "Tvoja sigurnost nam je prioritet.",
      "Naš Safety centre sadrži sve informacije i tu možeš naći svu podršku za sigurno upoznavanje.",
      "Posjeti naš Safety Centre",
      "Sigurnost <br/>nam je uvijek na prvom mjestu.",
      "Od prvog trenutka sam znao/la da je to ono pravo…",
      "U početku me nije zanimalo ništa ozbiljno…",
      "Najbolji savjet za sve osobe koje koriste aplikaciju Badoo je da budu ono što jesu...",
      "Uspješne Badoo priče",
      "Pogledaj više uspješnih priča",
      "{{num}}__CUT__Rejting",
      "Apple App Store",
      "Vjeruj nam. Spojili smo milione i milione ljudi od 2006. godine.",
      "{{num}}M+__CUT__preuzimanja",
      "{{num}}M+",
      "Google Play Store",
      "Iskusni smo u ovome.",
      "Prijavi se pomoću e-pošte ili broja telefona",
      "Unesi lozinku",
      "Zaboravio/la si lozinku?",
      "Registruj se",
      "Nemaš nalog?",
      "Prijava",
      "Registruj se"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "znaka",
                  "znaka",
                  "znaka",
                  "znaka",
                  "znaka",
                  "znaka",
                  "znaka"
            ],
            "plural": [
                  "znakova",
                  "znakova",
                  "znakova",
                  "znakova",
                  "znakova",
                  "znakova",
                  "znakova"
            ],
            "singular": [
                  "znak",
                  "znaka",
                  "znaku",
                  "znak",
                  "znaku",
                  "znakom",
                  "znače"
            ]
      },
      "day": {
            "few": [
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana"
            ],
            "plural": [
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana",
                  "dana"
            ],
            "singular": [
                  "dan",
                  "dana",
                  "danu",
                  "dan",
                  "o danu",
                  "danom",
                  "dane"
            ]
      },
      "hour": {
            "few": [
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata",
                  "sata"
            ],
            "plural": [
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati",
                  "sati"
            ],
            "singular": [
                  "sat",
                  "sata",
                  "satu",
                  "sat",
                  "satu",
                  "satom",
                  "sat"
            ]
      },
      "minute": {
            "few": [
                  "minute",
                  "minute",
                  "minute",
                  "minute",
                  "minute",
                  "minute",
                  "minute"
            ],
            "plural": [
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta",
                  "minuta"
            ],
            "singular": [
                  "minuta",
                  "minute",
                  "minuti",
                  "minutu",
                  "minuti",
                  "minutom",
                  "minuto"
            ]
      },
      "month": {
            "few": [
                  "mjeseca",
                  "mjeseca",
                  "mjeseca",
                  "mjeseca",
                  "mjeseca",
                  "mjeseca",
                  "mjeseca"
            ],
            "plural": [
                  "mjeseci",
                  "mjeseci",
                  "mjeseci",
                  "mjeseci",
                  "mjeseci",
                  "mjeseci",
                  "mjeseci"
            ],
            "singular": [
                  "mjesec",
                  "mjeseca",
                  "mjesecu",
                  "mjesec",
                  "mjesecu",
                  "mjesecom",
                  "mjeseče"
            ]
      },
      "second": {
            "few": [
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde",
                  "sekunde"
            ],
            "plural": [
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi",
                  "sekundi"
            ],
            "singular": [
                  "sekunda",
                  "sekunde",
                  "sekundi",
                  "sekundu",
                  "sekundi",
                  "sekundom",
                  "sekundom"
            ]
      },
      "year": {
            "few": [
                  "godine",
                  "godine",
                  "godine",
                  "godine",
                  "godinama",
                  "godinama",
                  "godine"
            ],
            "plural": [
                  "godina",
                  "godina",
                  "godina",
                  "godina",
                  "godine",
                  "godine",
                  "godina"
            ],
            "singular": [
                  "godina",
                  "godine",
                  "godini",
                  "godinu",
                  "godini",
                  "godinom",
                  "godino"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
